<section class="mainFiltersContainer">
    <lib-slide-toggle
        class="filter"
        label="Starred"
        [(checked)]="mainFilters.onlyFavorites"
        (checkedChange)="onFiltersChanged()"
    >
    </lib-slide-toggle>

    <lib-search-input
        class="filter"
        [placeholderText]="'OID or Name'"
        [(text)]="mainFilters.searchText"
        (textChange)="onFiltersChanged()"
    >
    </lib-search-input>
</section>
